import { Text } from "@chakra-ui/react"
import type { NextPage } from "next"

import XMLPretty from "@features/formatters/xml-pretty"

import Page from "@shared/ui/page"

const JSONPrettyPage: NextPage = () => {
  return (
    <Page title={"XML-formatter"}>
      <Text>Paste your XML below:</Text>
      <XMLPretty />
    </Page>
  )
}

export default JSONPrettyPage
